import { OffersCombinedApiClient } from '@fourthwall/services/dist/OffersCombinedApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useOfferCombinedDetachMutation = createMutationHook(
  OffersCombinedApiClient.detachOfferCombined,
  {
    mutationKey: ['offerCombinedDetach'],
  },
)
